const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#7a7a7a'
            },
            tertiary: {
                main: '#f3f3f3',
                light: '#e6e6e6',
                dark: '#9c9c9c',
                contrastText: '#666666'
            }
        }
    };
};

const themeDependent = (theme) => {
    return null;
};
    
export default {
    baseTheme,
    themeDependent
};
